import { FunctionComponent } from "react";
import ProtocolLayout from "../components/ProtocolLayout";

interface GoogleMeetBackgroundProps {}

const GoogleMeetBackground: FunctionComponent<
  GoogleMeetBackgroundProps
> = () => {
  return (
    <ProtocolLayout>
      <div className="flex flex-col items-center py-12">
        <div className="mb-12 text-3xl font-bold underline">
          Google Meet Background
        </div>
        <div className="grid lg:grid-cols-4 justify-items-center gap-y-5 lg:gap-y-0 w-4/5 mt-6 lg:mt-20">
          <a
            href="https://drive.google.com/file/d/1gSaU9oaMv0kl8-NrDG6oTGGbJP0kCCeL/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl">
                Google Meet Background 1
              </div>
            </div>
          </a>
          <a
            href="https://drive.google.com/file/d/1AJzRmRkWwZkyOm34IiJFf76HazBy1X90/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl">
                Google Meet Background 2
              </div>
            </div>
          </a>
          <a
            href="https://drive.google.com/file/d/1tKGs5ou4BGf6N6M402YUzFoC-MAInywS/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl">
                Google Meet Background 3
              </div>
            </div>
          </a>
          <a
            href="https://drive.google.com/file/d/17NeXnF2OvNDZs-iSciBF-zrI0_25yl2s/view?usp=drive_link"
            target="_blank"
            rel="noreferrer"
          >
            <div className="relative bg-gray-100 hover:bg-gray-200 duration-300 w-72 h-64 flex flex-col items-center justify-center rounded-xl shadow-lg py-12 px-4 ">
              <div className="">
                {/* <img src="/docs/gmc1.png" alt="" className="w-32" /> */}
              </div>
              <div className="mt-12 text-black text-opacity-40 font-bold text-xl">
                Google Meet Background 4
              </div>
            </div>
          </a>
        </div>
      </div>
    </ProtocolLayout>
  );
};

export default GoogleMeetBackground;
